// nl2br.js
// 간단한 nl2br 함수. php 의 같은 이름의 함수를 흉내냈다.
export default (val = '') => {
  if (!val || typeof val !== 'string') return ''
  return val.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '<br>')
}
